<template>
  <div class="wrapper">
    <div class="top">
      <div class="fixedCotanier">
        <div class="search-t">
          <div class="search-c">
            <img class="search" src="../../assets/images/search/search.svg" alt @click="search" />
            <input type="search" placeholder="请输入订单号/姓名/商品" v-model="searchinp" @keyup.13="search" />
            <img
              class="close"
              src="../../assets/images/search/close.svg"
              alt
              @click="returnHistory"
            />
          </div>
          <div class="return" @click="search">搜索</div>
        </div>
      </div>
      <van-tabs
        v-model="active"
        :swipe-threshold="5"
        color="#f44"
        sticky
        animated
        swipeable
        :line-width="30"
      >
        <van-tab title="全部" id="mid0">
          <div class="mid">
            <van-pull-refresh v-model="isLoading" @refresh="getdata(0,true)">
              <van-list
                v-model="loading"
                :finished="finished"
                :finished-text="list.length?'没有更多了':''"
                @load="getdata(pageIndex+ 1)"
                :immediate-check="false"
                :offset="20"
              >
                <div class="no" v-if="list.length == 0">
                  <img src="./../../assets/images/kb.png" alt />
                  <div>您暂时没有相关订单</div>
                </div>
                <div v-for="(item,index) in list" :key="index">
                  <!--待付款-->
                  <van-row class="box">
                    <van-row class="typelist" justify="space-between" type="flex">
                      <van-col>
                        <div
                          style="display:inline-block;marginRight:.1rem"
                        >共{{item.order.length}}件商品</div>
                        <!-- {{`${item.show_nbr.slice(0,4)}-${item.show_nbr.slice(4,6)}-${item.show_nbr.slice(6,8)} ${item.show_nbr.slice(8,10)}:${item.show_nbr.slice(10,12)}:${item.show_nbr.slice(12,14)}`}} -->
                        <span class="pt" v-show="item.is_group==1">拼团</span>
                      </van-col>
                      <van-col class="type">
                        {{
                        item.show.final_state == 4 ? '待付款'
                        : item.show.final_state == 6 ? (parseFloat(item.is_export)> 0?'备货中':'待发货')
                        : item.show.final_state == 7 ? '待收货'
                        : item.show.final_state == 8 ? '交易成功'
                        : item.show.final_state == 10 ? '交易关闭'
                        : item.show.final_state == 11 ? '退款中':''
                        }}
                      </van-col>
                    </van-row>
                    <div class="goodlistC">
                      <div v-for="(item1,index1) in item.order" :key="index1">
                        <van-row
                          class="goodlist"
                          type="flex"
                          
                          @click.native="goDetail(item.order_nbr)"
                        >
                          <img
                            :src="item1.inventory_logo||item1.commodity_first_pic + `${imgCrop}resize,w_300`"
                            alt
                          />
                          <van-row class="goodinfo">
                            <van-row class="name more-h">{{item1.commodity_name}}</van-row>
                            <van-row class="sigle">
                              <span class="sigle-h">{{item1.property}}</span>
                              <span style="color:#666">x{{item1.quantity}}</span>
                            </van-row>
                            <van-row type="flex" justify="space-between">
                              <van-col class="price">
                                <span style="font-weight:400;">￥{{item1.sell_price}}</span>
                              </van-col>
                              <!--<van-col>退款成功</van-col>-->
                            </van-row>
                          </van-row>
                        </van-row>
                        <van-row v-if="item1.remark" class="remark">
                          <span>{{item1.remark}}</span>
                        </van-row>
                      </div>
                    </div>
                    <van-row class="subtotal">
                      <span>
                        合计：
                        <span>¥{{item.sum_amount}}</span>
                        <span class="postage" v-if="item.postage>0">(含运费¥{{item.postage}})</span>
                      </span>
                    </van-row>
                    <van-row class="btn" v-show="item.show.final_state == 4">
                      <van-button
                        round
                        type="default"
                        size="small"
                        class="default"
                        @click.stop="cancelorder(item.order_nbr)"
                      >取消订单</van-button>
                      <van-button
                        round
                        type="default"
                        size="small"
                        class="purple"
                        @click.native.stop="gopay(item.order_nbr,item.sum_amount,item.group_leader_nbr,item.is_leader)"
                      >立即支付</van-button>
                    </van-row>
                    <van-row
                      class="btn"
                      v-show="item.show.final_state == 7 && item.is_refunding == 0&&item.order.is_refunding!=1"
                    >
                      <van-button
                        round
                        type="default"
                        size="small"
                        class="purple"
                        @click.native.stop="confirmreceipt(item.order_nbr)"
                      >确认收货</van-button>
                    </van-row>
                    <van-row class="btn" v-show="item.show.final_state == 8">
                      <van-button
                        round
                        type="default"
                        size="small"
                        class="default"
                        @click.stop="deleteorder(item.order_nbr)"
                      >删除订单</van-button>
                      <van-button
                        v-show="item.comment_state==1"
                        round
                        type="default"
                        size="small"
                        class="pink"
                        @click.native.stop="$router.push({path:'/evaluate',query:{nbr:item.order_nbr,supNbr:userInfo.nbr}})"
                      >评价</van-button>
                    </van-row>
                    <van-row class="btn" v-show="item.show.final_state == 10">
                      <van-button
                        round
                        type="default"
                        size="small"
                        class="default"
                        @click.stop="deleteorder(item.order_nbr)"
                      >删除订单</van-button>
                    </van-row>
                    <div class="orderService" @click.stop="clickItem=item;serviceChooseModal=true"><!--toService(item.show_nbr) -->
                      <img src="./../../assets/images/orders/orderService.png" alt/>
                      <span>联系客服</span>
                    </div>
                  </van-row>
                </div>
              </van-list>
            </van-pull-refresh>
          </div>
        </van-tab>
        <van-tab title="待付款" id="mid1">
          <div class="mid">
            <van-pull-refresh v-model="isLoading" @refresh="getdata(0,true)">
              <van-list
                v-model="loading"
                :finished="finished"
                :finished-text="list.length?'没有更多了':''"
                @load="getdata(pageIndex + 1)"
                :immediate-check="false"
                :offset="20"
              >
                <div class="no" v-if="list.length == 0">
                  <img src="./../../assets/images/kb.png" alt />
                  <div>您暂时没有相关订单</div>
                </div>
                <!--待付款-->
                <van-row class="box" v-for="(item,index) in list" :key="index">
                  <van-row class="typelist" justify="space-between" type="flex">
                    <van-col>
                      <div style="display:inline-block;marginRight:.1rem">共{{item.order.length}}件商品</div>
                      <!-- {{`${item.show_nbr.slice(0,4)}-${item.show_nbr.slice(4,6)}-${item.show_nbr.slice(6,8)} ${item.show_nbr.slice(8,10)}:${item.show_nbr.slice(10,12)}:${item.show_nbr.slice(12,14)}`}} -->
                      <span class="pt" v-show="item.is_group==1">拼团</span>
                    </van-col>
                    <van-col class="type">待付款</van-col>
                  </van-row>
                  <div class="goodlistC">
                    <div v-for="(item1,index1) in item.order" :key="index1">
                      <van-row
                        class="goodlist"
                        type="flex"
                        
                        @click.native="goDetail(item.order_nbr)"
                      >
                        <img
                          :src="item1.inventory_logo||item1.commodity_first_pic + `${imgCrop}resize,w_300`"
                          alt
                        />
                        <van-row class="goodinfo">
                          <van-row class="name more-h">{{item1.commodity_name}}</van-row>
                          <van-row class="sigle">
                            <span class="sigle-h">{{item1.property}}</span>
                            <span style="color:#666">x{{item1.quantity}}</span>
                          </van-row>
                          <van-row type="flex" justify="space-between">
                            <van-col class="price">
                              <span style="font-weight:400;">￥{{item1.sell_price}}</span>
                            </van-col>
                            <!--<van-col>退款成功</van-col>-->
                          </van-row>
                        </van-row>
                      </van-row>
                      <van-row v-if="item1.remark" class="remark">
                        <span>{{item1.remark}}</span>
                      </van-row>
                    </div>
                  </div>
                  <van-row class="subtotal">
                    <span>
                      合计：
                      <span>¥{{item.sum_amount}}</span>
                      <span class="postage" v-if="item.postage>0">(含运费¥{{item.postage}})</span>
                    </span>
                  </van-row>
                  <van-row class="btn">
                    <van-button
                      round
                      type="default"
                      size="small"
                      class="default"
                      @click.native.stop="cancelorder(item.order_nbr)"
                    >取消订单</van-button>
                    <van-button
                      round
                      type="default"
                      size="small"
                      class="purple"
                      @click.native.stop="gopay(item.order_nbr,item.sum_amount,item.group_leader_nbr,item.is_leader)"
                    >立即支付</van-button>
                  </van-row>
                  <div class="orderService" @click.stop="clickItem=item;serviceChooseModal=true"><!--toService(item.show_nbr) -->
                    <img src="./../../assets/images/orders/orderService.png" alt/>
                    <span>联系客服</span>
                  </div>
                </van-row>
              </van-list>
            </van-pull-refresh>
          </div>
        </van-tab>
        <van-tab title="待发货" id="mid2">
          <div class="mid">
            <van-pull-refresh v-model="isLoading" @refresh="getdata(0,true)">
              <van-list
                v-model="loading"
                :finished="finished"
                :finished-text="list.length?'没有更多了':''"
                @load="getdata(pageIndex + 1)"
                :immediate-check="false"
                :offset="20"
              >
                <div class="no" v-if="list.length == 0">
                  <img src="./../../assets/images/kb.png" alt />
                  <div>您暂时没有相关订单</div>
                </div>
                <!--待发货-->
                <van-row class="box" v-for="(item,index) in list" :key="index">
                  <van-row class="typelist" justify="space-between" type="flex">
                    <van-col>
                      <div style="display:inline-block;marginRight:.1rem">共{{item.order.length}}件商品</div>
                      <!-- {{`${item.show_nbr.slice(0,4)}-${item.show_nbr.slice(4,6)}-${item.show_nbr.slice(6,8)} ${item.show_nbr.slice(8,10)}:${item.show_nbr.slice(10,12)}:${item.show_nbr.slice(12,14)}`}} -->
                      <span class="pt" v-show="item.is_group==1">拼团</span>
                    </van-col>
                    <van-col class="type">{{(parseFloat(item.is_export)> 0?'备货中':'待发货')}}</van-col>
                  </van-row>
                  <div class="goodlistC">
                    <div v-for="(item1,index1) in item.order" :key="index1">
                      <van-row
                        class="goodlist"
                        type="flex"
                        
                        @click.native="goDetail(item.order_nbr)"
                      >
                        <img
                          :src="item1.inventory_logo||item1.commodity_first_pic + `${imgCrop}resize,w_300`"
                          alt
                        />
                        <van-row class="goodinfo">
                          <van-row class="name more-h">{{item1.commodity_name}}</van-row>
                          <van-row class="sigle">
                            <span class="sigle-h">{{item1.property}}</span>
                            <span style="color:#666">x{{item1.quantity}}</span>
                          </van-row>
                          <van-row type="flex" justify="space-between">
                            <van-col class="price">
                              <span style="font-weight:400;">￥{{item1.sell_price}}</span>
                            </van-col>
                            <!--<van-col>退款成功</van-col>-->
                          </van-row>
                        </van-row>
                      </van-row>
                      <van-row v-if="item1.remark" class="remark">
                        <span>{{item1.remark}}</span>
                      </van-row>
                    </div>
                  </div>
                  <van-row class="subtotal">
                    <span>
                      合计：
                      <span>¥{{item.sum_amount}}</span>
                      <span class="postage" v-if="item.postage>0">(含运费¥{{item.postage}})</span>
                    </span>
                  </van-row>
                 <div class="orderService" @click.stop="clickItem=item;serviceChooseModal=true"><!--toService(item.show_nbr) -->
                    <img src="./../../assets/images/orders/orderService.png" alt/>
                    <span>联系客服</span>
                  </div>
                </van-row>
              </van-list>
            </van-pull-refresh>
          </div>
        </van-tab>
        <van-tab title="待收货" id="mid3">
          <div class="mid">
            <van-pull-refresh v-model="isLoading" @refresh="getdata(0,true)">
              <van-list
                v-model="loading"
                :finished="finished"
                :finished-text="list.length?'没有更多了':''"
                @load="getdata(pageIndex + 1)"
                :immediate-check="false"
                :offset="20"
              >
                <div class="no" v-if="list.length == 0">
                  <img src="./../../assets/images/kb.png" alt />
                  <div>您暂时没有相关订单</div>
                </div>
                <!--待收货-->
                <van-row class="box" v-for="(item,index) in list" :key="index">
                  <van-row class="typelist" justify="space-between" type="flex">
                    <van-col>
                      <div style="display:inline-block;marginRight:.1rem">共{{item.order.length}}件商品</div>
                      <!-- {{`${item.show_nbr.slice(0,4)}-${item.show_nbr.slice(4,6)}-${item.show_nbr.slice(6,8)} ${item.show_nbr.slice(8,10)}:${item.show_nbr.slice(10,12)}:${item.show_nbr.slice(12,14)}`}} -->
                      <span class="pt" v-show="item.is_group==1">拼团</span>
                    </van-col>
                    <van-col class="type">待收货</van-col>
                  </van-row>
                  <div class="goodlistC">
                    <div v-for="(item1,index1) in item.order" :key="index1">
                      <van-row
                        class="goodlist"
                        type="flex"
                        
                        @click.native="goDetail(item.order_nbr)"
                      >
                        <img
                          :src="item1.inventory_logo||item1.commodity_first_pic + `${imgCrop}resize,w_300`"
                          alt
                        />
                        <van-row class="goodinfo">
                          <van-row class="name more-h">{{item1.commodity_name}}</van-row>
                          <van-row class="sigle">
                            <span class="sigle-h">{{item1.property}}</span>
                            <span style="color:#666">x{{item1.quantity}}</span>
                          </van-row>
                          <van-row type="flex" justify="space-between">
                            <van-col class="price">
                              <span style="font-weight:400;">￥{{item1.sell_price}}</span>
                            </van-col>
                            <!--<van-col>退款成功</van-col>-->
                          </van-row>
                        </van-row>
                      </van-row>
                      <van-row v-if="item1.remark" class="remark">
                        <span>{{item1.remark}}</span>
                      </van-row>
                    </div>
                  </div>
                  <van-row class="subtotal">
                    <span>
                      合计：
                      <span>¥{{item.sum_amount}}</span>
                      <span class="postage" v-if="item.postage>0">(含运费¥{{item.postage}})</span>
                    </span>
                  </van-row>
                  <van-row class="btn" v-if="item.is_refunding==0">
                    <!--<van-button round type="default" size="small" class="default"
                  @click.native.stop="$router.push({path: '/logistics',query:{nbr:item1.order_nbr,supNbr:this.userInfo.nbr}})">查看物流
                    </van-button>-->
                    <van-button
                      v-if="item.is_refunding==0"
                      round
                      type="default"
                      size="small"
                      class="purple"
                      @click.native.stop="confirmreceipt(item.order_nbr)"
                    >确认收货</van-button>
                  </van-row>
                 <div class="orderService" @click.stop="clickItem=item;serviceChooseModal=true"><!--toService(item.show_nbr) -->
                    <img src="./../../assets/images/orders/orderService.png" alt/>
                    <span>联系客服</span>
                  </div>
                </van-row>
              </van-list>
            </van-pull-refresh>
          </div>
        </van-tab>
        <van-tab title="待评价" id="mid4">
          <div class="mid">
            <van-pull-refresh v-model="isLoading" @refresh="getdata(0,true)">
              <van-list
                v-model="loading"
                :finished="finished"
                :finished-text="list.length?'没有更多了':''"
                @load="getdata(pageIndex + 1)"
                :immediate-check="false"
                :offset="20"
              >
                <div class="no" v-if="list.length == 0">
                  <img src="./../../assets/images/kb.png" alt />
                  <div>您暂时没有相关订单</div>
                </div>
                <!--待评价-->
                <van-row class="box" v-for="(item,index) in list" :key="index">
                  <van-row class="typelist" justify="space-between" type="flex">
                    <van-col>
                      <div style="display:inline-block;marginRight:.1rem">共{{item.order.length}}件商品</div>
                      <!-- {{`${item.show_nbr.slice(0,4)}-${item.show_nbr.slice(4,6)}-${item.show_nbr.slice(6,8)} ${item.show_nbr.slice(8,10)}:${item.show_nbr.slice(10,12)}:${item.show_nbr.slice(12,14)}`}} -->
                      <span class="pt" v-show="item.is_group==1">拼团</span>
                    </van-col>
                    <van-col class="type">交易成功</van-col>
                  </van-row>
                  <div class="goodlistC">
                    <div v-for="(item1,index1) in item.order" :key="index1">
                      <van-row
                        class="goodlist"
                        type="flex"
                        
                        @click.native="goDetail(item.order_nbr)"
                      >
                        <img
                          :src="item1.inventory_logo||item1.commodity_first_pic + `${imgCrop}resize,w_300`"
                          alt
                        />
                        <van-row class="goodinfo">
                          <van-row class="name more-h">{{item1.commodity_name}}</van-row>
                          <van-row class="sigle">
                            <span class="sigle-h">{{item1.property}}</span>
                            <span style="color:#666">x{{item1.quantity}}</span>
                          </van-row>
                          <van-row type="flex" justify="space-between">
                            <van-col class="price">
                              <span style="font-weight:400;">￥{{item1.sell_price}}</span>
                            </van-col>
                            <!--<van-col>退款成功</van-col>-->
                          </van-row>
                        </van-row>
                      </van-row>
                      <van-row v-if="item1.remark" class="remark">
                        <span>{{item1.remark}}</span>
                      </van-row>
                    </div>
                  </div>
                  <van-row class="subtotal">
                    <span>
                      合计：
                      <span>¥{{item.sum_amount}}</span>
                      <span class="postage" v-if="item.postage>0">(含运费¥{{item.postage}})</span>
                    </span>
                  </van-row>
                  <van-row class="btn">
                    <van-button
                      round
                      type="default"
                      size="small"
                      class="default"
                      @click.stop="deleteorder(item.order_nbr)"
                    >删除订单</van-button>
                    <van-button
                      round
                      type="default"
                      size="small"
                      class="pink"
                      @click.native.stop="$router.push({path:'/evaluate',query:{nbr:item.order_nbr,supNbr:userInfo.nbr}})"
                    >评价</van-button>
                  </van-row>
                  <div class="orderService" @click.stop="clickItem=item;serviceChooseModal=true"><!--toService(item.show_nbr) -->
                    <img src="./../../assets/images/orders/orderService.png" alt/>
                    <span>联系客服</span>
                  </div>
                </van-row>
              </van-list>
            </van-pull-refresh>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <pay
      :order_number="order_number"
      :paymoney="paymoney"
      :groupLeaderNbr="groupLeaderNbr"
      :state="state"
      ref="pay"
      @goback="goback"
      @paysuccess="paysuccess"
    ></pay>
    <!--取消订单-->
    <van-popup v-model="show" :close-on-click-overlay="false">
      <van-row class="popup">
        <van-row class="content" type="flex" justify="center" align="center">确定要取消订单吗？</van-row>
        <van-row>
          <van-col class="cancel" @click.native="show=false">取消</van-col>
          <van-col class="confirm" @click.native="confirm">确定</van-col>
        </van-row>
      </van-row>
    </van-popup>
    <!--删除订单-->
    <van-popup v-model="showdelete" :close-on-click-overlay="false">
      <van-row class="popup">
        <van-row class="content" type="flex" justify="center" align="center">确定要删除订单吗？</van-row>
        <van-row>
          <van-col class="cancel" @click.native="showdelete=false">取消</van-col>
          <van-col class="confirm" @click.native="confirmDelete">确定</van-col>
        </van-row>
      </van-row>
    </van-popup>
    <!--确认收货-->
    <van-popup v-model="shouhuoshow" :close-on-click-overlay="false">
      <van-row class="popup">
        <van-row class="content" type="flex" justify="center" align="center">确认收货后无法退款哦～</van-row>
        <van-row>
          <van-col class="cancel" @click.native="shouhuoshow=false">取消</van-col>
          <van-col class="confirm" @click.native.stop="confirmshouhuo">确定</van-col>
        </van-row>
      </van-row>
    </van-popup>

    <!--规格弹窗-->
    <van-popup v-model="propertyModal" :close-on-click-overlay="true">
      <van-row class="popup1">
        <van-row class="title">已选规格：</van-row>
        <van-row class="propertyText">{{propertyText}}</van-row>
      </van-row>
    </van-popup>

    <!-- 客服选择弹窗 -->
    <van-popup v-model="serviceChooseModal" position="bottom" style="border-radius: 0.2rem 0.2rem 0 0;" :close-on-click-overlay="false">
      <div class="serviceChooseBox">
        <div class="title">
          <span>客服工作时间：08:30-20:30</span>
        </div>
        <div class="serviceItem" @click.stop="toService">
          <div class="imgBox">
            <img src="./../../assets/images/orders/onlineService.png" alt />
            <div class="recommend">
              <span>推荐</span>
            </div>
          </div>
          <div class="serviceText">
            <div class="serviceTitle">
              <span>在线客服</span>
            </div>
            <div class="serviceDesc">
              <span class="serviceDescText">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;点击联系在线客服，我们将全心全意为您提供满意周到的咨询服务</span>
              <div class="serviceIcon">
                <span>立即咨询</span>
              </div>
            </div>
          </div>
        </div>
        <a style="margin-top:.44rem" href="tel:15289896367">
        <div class="serviceItem">
          <div class="imgBox">
            <img src="./../../assets/images/orders/onlineService.png" alt />
          </div>
          <div class="serviceText">
            <div class="serviceTitle">
              <span>售后热线</span>
            </div>
            <div class="serviceDesc">
              <span class="serviceDescText">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;售后客服电话，咨询人数较多，建议优先选择在线客服</span>
              <div class="serviceIcon" style="width:1.88rem;">
                <span>当前预计等待5分钟</span>
              </div>
            </div>
          </div>
        </div>
        </a>
        <div class="closeBtn" @click.stop="clickItem={};serviceChooseModal = false">
          <span>取消</span>
        </div>
      </div>
    </van-popup>

    <!-- 客服弹窗 -->
    <van-popup v-model="serviceModal" style="border-radius: 0.2rem;">
      <div class="servicebox">
        <img
          class="serviceimg"
          @click.stop="serviceModal = false"
          src="./../../assets/images/information/Close.svg"
          alt
        />
        <div class="servicespan">
          <p class="wechat">有米日记服务中心</p>
          <span>有米日记售后系统上线啦！</span>
          <span>长按识别小程序码，即可体验全新售后体验</span>
          <!--<span>菜单底部直接联系客服</span>-->
        </div>
        <div class="codeimg">
          <img src="./../../assets/images/xcx_qrcode.jpg" alt />
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import pay from "./pay";
import { mapGetters } from "vuex";
import axios from "axios";
import weChatShareApi from "../../assets/js/weChatShare";
export default {
  components: {
    pay: pay
  },
  props: {},
  mixins: [weChatShareApi],
  data() {
    return {
      paymoney: 0, //付款的钱
      order_number: "", //付款的订单号
      cancelNbr: "", //取消订单的订单号
      show: false,
      active: 0,
      isLoading: false,
      loading: false,
      finished: false,
      cancelid: "", //取消订单的id
      list: [],
      pageIndex: 0,
      numPerPage: 10,
      keepAlive: true, //
      source: null, //存放取消的请求方法
      scroll: 0, //页面离开时的 mid div的滚轮高度
      shouhuoid: "", //确认收货的id
      shouhuoshow: false, //
      showdelete: false, //
      tabIndex: 0, // tab下标
      propertyText: "",
      propertyModal: false,
      deleteNbr: "", // 删除订单
      searchinp: "",
      oldSearch: "",
      groupLeaderNbr: "",
      state: "",
      serviceChooseModal:false,
      serviceModal:false,
      clickItem:{},
      info:{},
    };
  },
  watch: {
    active(val, old) {
      if (typeof this.source === "function") {
        this.source("终止请求"); //取消请求
        this.loading = true; //手动控制上啦正在加载，防止多次请求
        this.list = [];
        this.pageIndex = 0;
      }
      this.getdata(0);
    },
    $route(to, from) {
      if (from.path == "/information" || from.path == "/payResultFollow") {
        this.keepAlive = true;
      } else {
        this.keepAlive = false;
      }
    }
  },
  computed: {
    ...mapGetters(["payment","receive"])
  },
  methods: {
    toService(){
      let item= this.clickItem
      let note = {
        orderNbr: item.show_nbr
      }
      let time=new Date(item.create_time).getTime()/1000
      let adminUrl=`https://ymrjmanager.kjyoumi.com/ysfIframe?openid=${this.userInfo.nbr}&note=${JSON.stringify(note)}`
      let goods = item.order[0]
      let orderInfo=`tmptype=order&tmpTitle=${encodeURIComponent(goods.commodity_name)}&tmporderThumb=${encodeURIComponent(goods.commodity_first_pic)}&tmporderid=${item.show_nbr}&tmpordertime=${time}&tmpordernum=${goods.quantity}&tmporderprice=${item.sum_amount}&tmporderstaffurl=${encodeURIComponent(adminUrl)}&isauto=0`
      let url = `https://kefu.kjyoumi.com/api/mobileweb/home?channel_id=34483&channel_key=34483zkeq&wechatapp_id=345097&key=76967s450&openid=${this.userInfo.nbr}&nickName=${encodeURIComponent(this.info.nick_name)}&avatarUrl=${encodeURIComponent(this.info.head_pic)}&mobile=${this.info.phone_no||''}&note=${JSON.stringify(note)}&${orderInfo}`
      let u = navigator.userAgent
      let isandroid = u.indexOf('android') > -1 || u.indexOf('adr') > -1;
      if(isandroid) url=url+'&isvivo=1'
      // window.open(url)
      this.$router.push({
        path: "/iframe",
        query: {
          title: encodeURIComponent('在线客服'),
          url: encodeURIComponent(url),
        },
      });
    },
    showService() {
      this.serviceModal = true;
    },
    showProperty(text) {
      this.propertyText = text;
      this.propertyModal = true;
    },
    gopay(orders_num, money, groupLeaderNbr, isLeader) {
      this.paymoney = money;
      this.order_number = orders_num;
      this.groupLeaderNbr = groupLeaderNbr||'';
      this.state = isLeader||'';
      this.$refs.pay.showpay();
    },
    goDetail(nbr) {
      this.$router.push({
        path: "/orderdetail",
        query: { nbr: nbr, supNbr: this.userInfo.nbr }
      });
    },
    returnHistory() {
      this.searchinp = "";
      this.oldSearch = "";
      this.getdata(0, true);
    },
    search() {
      this.loading = true; //手动控制上啦正在加载，防止多次请求
      this.finished = true;
      this.list = [];
      this.pageIndex = 0;
      document.getElementById("mid" + this.active).scrollTop = 0;
      this.oldSearch = this.searchinp;
      this.getdata(0);
    },
    /**
     *支付失败
     */
    goback() {},
    /**
     *支付成功
     */
    paysuccess() {
      this.list = [];
      this.getdata(0);
    },
    /**
     * 确认收货
     * @param b_id 大订单号
     */
    confirmreceipt(b_id) {
      this.shouhuoid = b_id;
      this.shouhuoshow = true;
    },
    cancelorder(nbr) {
      this.cancelNbr = nbr;
      this.show = true;
    },
    deleteorder(nbr) {
      this.deleteNbr = nbr;
      this.showdelete = true;
    },
    confirmDelete() {
      let that = this;
      const toast = this.$toast({
        type: "loading",
        message: "正在提交...",
        duration: 0,
        mask: true
      });
      this.$commonPost({
        jydm: "flow_10000",
        flow_10000: {
          sub_flow: "flow_30029",
          nbr: this.deleteNbr
        }
      })
        .then(resp => {
          this.$toast({
            message: "删除订单成功",
            duration: 1000
          });
          this.showdelete = false;
          this.$store.commit("SENDpayment", 1);
          this.list = [];
          this.getdata(0);
        })
        .catch(err => {
          this.showdelete = false;
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    confirm() {
      // 加载框子
      const toast = this.$toast({
        type: "loading",
        message: "正在提交...",
        duration: 0,
        mask: true
      });
      this.$commonPost({
        jydm: "flow_10000",
        flow_10000: {
          sub_flow: "flow_30032",
          order_nbr: this.cancelNbr
        }
      })
        .then(resp => {
          this.show = false;
          this.loading = true;
          this.$toast({
            message: "订单取消成功",
            duration: 1000
          });
          this.list = [];
          this.getdata(0);
        })
        .catch(err => {
          this.show = false;
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    confirmshouhuo() {
      // 加载框子
      const toast = this.$toast({
        type: "loading",
        message: "正在提交...",
        duration: 0,
        mask: true
      });
      this.$commonPost({
        jydm: "flow_10000",
        flow_10000: {
          sub_flow: "flow_30034",
          order_nbr: this.shouhuoid
        }
      })
        .then(response => {
          this.shouhuoshow = false;
          this.loading = true;

          let list = this.list
          if(this.active==3){
            let orderIndex = ''
            for(let i=0;i<list.length;i++){
              if(list[i].order_nbr==this.shouhuoid){
                orderIndex = i
                break;
              }
            }
            list.splice(orderIndex, 1)
          }else if(this.active==0){
            for(let i=0;i<list.length;i++){
              if(list[i].order_nbr==this.shouhuoid){
                list[i].show.final_state = '8'
                break;
              }
            }
          }
          
          this.loading = true;
          // this.list = [];
          // this.getdata(0);
          this.$toast({
            message: "已完成收货",
            duration: 2000
          });
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    getdata(index, iSwitch) {
      let obj = {};
      let active = this.active;
      let search = "";
      let state;
      this.loading = true; //手动控制上啦正在加载，防止多次请求
      if (iSwitch || this.tabIndex != active) {
        //判断存在就是下拉刷新  换页清空
        this.finished = false;
        this.list = [];
      }
      this.pageIndex = index;
      this.tabIndex = active;
      if (active == 0) {
        state = -1;
      } else if (active == 1) {
        state = 4;
      } else if (active == 2) {
        state = 6;
      } else if (active == 3) {
        state = 7;
      }

      if (active == 4) {
        obj = {
          jydm: "flow_30021",
          flow_30021: {
            user_nbr: this.userInfo.nbr,
            page_index: index * this.numPerPage,
            num_per_page: this.numPerPage,
            search: this.oldSearch,
            wechat_version: 1
          }
        };
      } else {
        obj = {
          jydm: "flow_30010",
          flow_30010: {
            user_nbr: this.userInfo.nbr,
            final_state: state,
            page_index: index * this.numPerPage,
            num_per_page: this.numPerPage,
            search: this.oldSearch,
            wechat_version: 1
          }
        };
      }

      //
      this.$commonPost(obj)
        .then(resp => {
          let iArr = this.list;
          if (resp.order_list) {
            if (resp.order_list.length > 0) {
              resp.order_list.map(item => {
                let jArr = [];
                if (item.order) {
                  if (item.order.length > 0) {
                    jArr = item.order;
                  } else {
                    jArr.push(item.order);
                  }
                }
                item.order = jArr;
              });
              iArr = iArr.concat(resp.order_list);
            } else {
              let jArr = [];
              if (resp.order_list.order) {
                if (resp.order_list.order.length > 0) {
                  jArr = resp.order_list.order;
                } else {
                  jArr.push(resp.order_list.order);
                }
              }
              resp.order_list.order = jArr;
              iArr.push(resp.order_list);
            }
          }

          if (!resp.order_list || resp.order_list.length < this.numPerPage) {
            this.finished = true;
          } else {
            this.finished = false;
          }
          this.list = iArr;
          this.loading = false;
          this.isLoading = false;
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    initPage() {
      let option = {
        title: "有米@" + this.userInfo.name + "的店铺",
        desc: "欢迎光临我的店铺",
        link: location.origin + "/?supNbr=" + this.userInfo.nbr,
        images: this.userInfo.imgUrl
      };
      this.weChatShare(option);
      if (this.payment) {
        this.list = [];
        this.getdata(0);
        this.$store.commit("SENDpayment", "");
      }
      if(this.receive){
        let list = this.list
        if(this.active==3){
          let orderIndex = ''
          for(let i=0;i<list.length;i++){
            if(list[i].order_nbr==this.receive){
              orderIndex = i
              break;
            }
          }
          list.splice(orderIndex, 1)
        }else if(this.active==0){
          for(let i=0;i<list.length;i++){
            if(list[i].order_nbr==this.receive){
              list[i].show.final_state=='8'
              break;
            }
          }
        }
        this.$store.commit("SENDreceive", "");
      }
      if (!this.keepAlive) {
        //将高度滚动到原来离开页面的高度
        document.getElementById("mid" + this.active).scrollTop = this.scroll;
        return false;
      }
      //果然从上个页面过来 参数与当前选中索引一样则手动刷新列表
      if (this.active == Number(this.$route.query.index)) {
        this.list = [];
        this.getdata(0);
      } else {
        this.active = Number(this.$route.query.index);
      }
    },
    getUserInfo(){
      this.$commonPost({
        jydm: "flow_10003",
        flow_10003: {
          user_nbr: this.userInfo.nbr,
        },
      }).then((resp) => {
        this.info = resp;
      }).catch((err) => {});
    },
  },
  //被缓存时任执行
  activated() {
    document.title = "我的订单";
    this.initPage();
    this.getUserInfo();
  },
  beforeRouteLeave(to, from, next) {
    if (to.path == "/placeorder") {
      this.$router.replace({
        path: "/information",
        query: { supNbr: this.userInfo.nbr }
      });
    }
    if (to.path == "/information") {
      this.searchinp = "";
      this.oldSearch = "";
    }
    //在路由监听里面控制 是否缓存
    //记录离开页面元素的高度
    this.scroll = document.getElementById("mid" + this.active).scrollTop;
    next();
  },
  created() {
    this.tabIndex = this.$route.query.index;
  },
  mounted() {}
};
</script>
<style scoped lang='stylus'>
.top >>> .van-tabs--line .van-tabs__wrap {
  height: 0.8rem;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
}

.top >>> .van-tab {
  background: #FFFFFF;
  font-size: 0.28rem;
  color: #333333;
  line-height: 0.8rem;
}

.top >>> .van-tab--active {
  font-weight: normal !important;
  font-size: 0.28rem;
  color: #E52B25;
}

.top >>> .van-tab__pane {
  height: calc(100vh - 1.68rem);
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
}

.top >>> .van-tabs--line {
  padding-top: 0.8rem;
}

.mid >>> .van-pull-refresh__track {
  min-height: calc(100vh - 2rem);
}

.mid >>> .no {
  margin: 0 auto 0;
  padding-top: 2rem;
  text-align: center;
}

.van-row::after {
  display: none;
}

.box >>> .van-button--small {
  line-height: 0;
}

.box >>> {
  line-height: 0;
}
</style>
<style scoped lang='less'>
.fixedCotanier {
  background: #fff;
  width: 100%;
  box-shadow: 0 2px 18px 0 rgba(0, 0, 0, 0.02);
  padding: 0.14rem 0;
}
.search-t {
  margin: 0 auto;
  width: 7.02rem;
  height: 0.6rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.search-t .search-c {
  flex: 1;
  background-color: #f9f9f9;
  border-radius: 0.3rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.search-t .return {
  color: #333;
  font-size: 0.28rem;
  margin-left: 0.24rem;
}
.search-t .return img {
  width: 0.4rem;
  height: 0.4rem;
}
.search-t .search {
  margin-left: 0.18rem;
  vertical-align: middle;
  width: 0.36rem;
  height: 0.36rem;
}
.search-t .close {
  margin-right: 0.18rem;
  vertical-align: middle;
  width: 0.36rem;
  height: 0.36rem;
}
.search-t input {
  flex: 1;
  display: inline-block;
  margin-left: 0.18rem;
  background: none;
  border: none;
  //   color: #f7f7f7;
  line-height: 0.6rem;
  font-size: 0.28rem;
}
input[type="search"]::-webkit-search-cancel-button {
  -webkit-appearance: none;
}
.search-t input::-webkit-input-placeholder {
  color: #999;
}
.search-t input::-ms-input-placeholder {
  //由于我的IE刚好是IE9，支持不了placeholder，所以也测试不了(⊙﹏⊙)，有IE10以上的娃可以帮我试试
  color: #999;
}
.no {
  img {
    width: 3.64rem;
    height: 2.1rem;
    margin-bottom: 0.6rem;
  }
}
.sigle {
  width: 4.4rem;
  margin-top: 0.1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  span:after {
    display: none;
  }
  .sigle-h {
    width: 3.8rem;
    line-height: 0.3rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    word-break: break-all;
    white-space: normal;
  }
}
.wrapper {
  background: #f5f5f5;
  width: 100%;
  .top {
    height: 100vh;
  }
}

.mid {
  padding: 0.28rem 0.28rem 0;
  box-sizing: border-box;
  max-height: calc(100vh - 1.68rem);
  .box {
    padding: 0 0.24rem 0.2rem;
    box-sizing: border-box;
    background: #ffffff;
    margin-bottom: 0.2rem;
    box-shadow: 0 0.12rem 0.24rem 0 rgba(242, 242, 242, 0.5);
    border-radius: 0.16rem;
    position: relative;
    .orderService{
      position: absolute;
      bottom: .15rem;
      left:.2rem;
      height: .4rem;
      display: flex;
      flex-direction: row;
      align-items: center;
      img{
        width: .4rem;
        height: .4rem;
        margin-right: .04rem;
      }
      span{
        font-size: .24rem;
        color: #007AFF;
        font-weight: 500;
      }
    }
    .typelist {
      height: 0.68rem;
      line-height: 0.68rem;
      font-size: 0.24rem;
      color: #999999;
      .type {
        color: #e52b25;
        font-weight: bold;
      }
      .van-col {
        display: flex;
        justify-content: center;
        align-items: center;
        .pt {
          width: 1.26rem;
          height: 0.68rem;
          margin-left: -0.14rem;
          display: flex;
          justify-content: center;
          align-items: center;
          background-image: linear-gradient(-90deg, #fd3741 0%, #fe7202 100%);
          border-radius: 0.04rem;
          color: #fff;
          font-size: 0.4rem;
          transform: scale(0.5);
        }
      }
    }
    .goodlistC {
      margin-top: 0.2rem;
      border-bottom: 1px solid #eee;
    }
    .goodlist {
      margin-bottom: 0.22rem;
      img {
        width: 2rem !important;
        height: 2rem !important;
        object-fit: cover;
      }
      .goodinfo {
        flex: 1;
        width: 100%;
        margin-left: 0.12rem;
        font-size: 0.24rem;
        color: #999999;
        line-height: 0.32rem;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        position: relative;
        .sigle-h {
          font-size: 0.22rem;
        }
        .name {
          color: #333333;
          width: 4.4rem;
          font-weight: bold;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          word-break: break-all;
          white-space: normal;
        }
      }
      .price {
        position: absolute;
        font-size: 0.28rem;
        color: #666;
        bottom: 0;
        .old {
          font-size: 0.2rem;
        }
      }
      .goodinfo:after {
        display: none;
      }
    }
    .remark{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      line-height: .3rem;
      margin-bottom: 0.1rem;
      span{
        color: #333;
        font-size: 0.24rem;
      }
    }
    .subtotal {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      height: 0.3rem;
      margin-top: 0.22rem;
      span {
        color: #333;
        font-size: 0.24rem;
        span {
          color: #e52b25;
          font-size: 0.34rem;
        }
        .postage {
          color: #333;
          font-size: 0.2rem;
          margin-left: 0.04rem;
        }
      }
    }
    .btn {
      text-align: right;
      margin-top: 0.22rem;
      display: flex;
      justify-content: flex-end;
      .default {
        width: 1.52rem;
        color: #333;
        height: 0.5rem;
        font-size: 0.25rem;
        box-sizing: border-box;
        border: 0.02rem solid #cccccc;
        display: flex;
        justify-content: center;
        align-items: center;
        line-height: 0.38rem;
        font-size: 0.26rem;
      }
      .purple {
        width: 1.52rem;
        background: #e52b25;
        height: 0.5rem;
        color: #ffffff;
        font-size: 0.25rem;
        margin-left: 0.2rem;
        box-sizing: border-box;
        border: none;
        display: flex;
        justify-content: center;
        align-items: center;
        line-height: 0.38rem;
        font-size: 0.26rem;
      }
      .pink {
        width: 1.52rem;
        height: 0.5rem;
        color: #e52b25;
        margin-left: 0.2rem;
        box-sizing: border-box;
        border: 0.02rem solid #e52b25;
        display: flex;
        justify-content: center;
        align-items: center;
        line-height: 0.38rem;
        font-size: 0.26rem;
      }
    }
  }
}

/*取消订单*/
.van-popup {
  border-radius: 0.18rem;
}
.popup1 {
  width: 6.3rem;
  min-height: 3.2rem;
  .title {
    margin: 0.48rem 0.4rem 0.2rem;
    color: #333;
    font-weight: bold;
  }
  .propertyText {
    margin: 0 0.4rem 0.5rem;
    color: #333;
    line-height: 0.4rem;
  }
}
.popup {
  width: 6.14rem;
  height: 3.04rem;
  .content {
    font-weight: 400;
    height: 1.96rem;
    text-align: center;
    font-size: 0.3rem;
    color: #333333;
    border-bottom: 1px solid #eeeeee;
  }
  .cancel {
    height: 1.07rem;
    text-align: center;
    line-height: 1.07rem;
    width: 50%;
    font-weight: 500;
    font-size: 0.3rem;
    color: #333333;
    border-right: 1px solid #eeeeee;
  }
  .confirm {
    height: 1.07rem;
    text-align: center;
    line-height: 1.07rem;
    width: 50%;
    font-size: 0.3rem;
    font-weight: 500;
    color: #e52b25;
  }
}
.servicebox {
  width: 6.14rem;
  height: 7.66rem;
  background: #ffffff;
  box-shadow: 0 0.02rem 0.34rem 0 rgba(239, 51, 66, 0.12);
  .serviceimg {
    width: 0.4rem;
    height: 0.4rem;
    position: absolute;
    top: 0.2rem;
    right: 0.2rem;
  }
  .servicespan {
    padding-top: 0.75rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 0.26rem;
    color: #999;
    text-align: center;
    margin-bottom: 0.62rem;
    span {
      line-height: 0.4rem;
    }
    .wechat {
      font-size: 0.4rem;
      color: #000000;
      font-weight: bold;
      margin-bottom: 0.1rem;
      line-height: 0.56rem;
    }
  }
  .codeimg {
    display: flex;
    justify-content: center;
    align-items: center;
    background-position: center;
    img {
      width: 4rem;
      height: 4rem;
    }
  }
}
.serviceChooseBox{
  width: 100%;
  height: 7.72rem;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  .title{
    margin-top: .48rem;
    margin-bottom: 1.06rem;
    height: .42rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    span{
      font-size: 0.3rem;
      color: #333333;
      font-weight: bold;
    }
  }
  .serviceItem{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    height: 1.6rem;
    width: 100%;
    padding: .16rem .24rem 0;
    box-sizing: border-box;
    .imgBox{
      position: relative;
      width: .94rem;
      height: .94rem;
      margin-right: .26rem;
      img{
        width: .94rem;
        height: .94rem;
      }
      .recommend{
        position: absolute;
        bottom: -.06rem;
        right: .04rem;
        width: .66rem;
        height: .3rem;
        background-image: linear-gradient(90deg, #F28B63 3%, #EB6388 97%);
        border-radius: .18rem 0 .18rem 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        span{
          font-size: 0.2rem;
          color: #fff;
          font-weight: 500;
        }
      }
    }
    .serviceText{
      flex-direction: column;
      .serviceTitle{
        height:.42rem;
        margin-bottom: .2rem;
        display: flex;
        flex-direction: row;
        align-items: center;
        span{
          font-size: 0.3rem;
          color: #333;
          font-weight: bold;
        }
      }
      .serviceDesc{
        position: relative;
        line-height: .33rem;
        .serviceDescText{
          font-size: 0.24rem;
          color: #333;
          font-weight: 500;
        }
        .serviceIcon{
          position: absolute;
          top: 0.02rem;
          left: 0;
          width: .94rem;
          height: .3rem;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          background: #FEE3EA;
          border-radius: .02rem;
          span{
            font-size: 0.2rem;
            color: #FF0011;
            font-weight: bold;
          }
        }
      }
    }
  }
  .closeBtn{
     margin-top: .9rem;
    width: 6.78rem;
    height: .98rem;
    background: #F7F7F7;
    border-radius: .08rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    span{
      font-size: 0.28rem;
      color: #333333;
      font-weight: 500;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/information/myorder.vue